<div class="accordion" id="accordionSummaryCoupons">
  <div class="accordion-item">
    <button
      class="sidebar__trigger"
      data-bs-toggle="collapse"
      data-bs-target="#collapseSummaryCoupons"
      aria-expanded="true"
      aria-controls="collapseSummaryCoupons"
      [class.collapsed]="collapseByVoucherSelected"
    >
      <h5 class="h5 sidebar__section-title">
        {{ 'sharedModule.bkgSummaryVouchers.title' | translate }}
      </h5>
    </button>

    <div
      id="collapseSummaryCoupons"
      class="accordion-collapse collapse"
      [class.show]="!collapseByVoucherSelected"
      data-bs-parent="#accordionSummaryCoupons"
    >
      <div class="accordion-body">
        <div class="sidebar__content">
          <bkg-voucher-list
            [vouchers]="vouchers"
            [selectedVoucherCode]="selectedVoucherCode"
            (addVoucherCodeReturn)="onCouponSelected($event)"
          ></bkg-voucher-list>
        </div>
      </div>
    </div>
  </div>
</div>
